import { render, staticRenderFns } from "./TextText.vue?vue&type=template&id=bb5b53dc&scoped=true&"
import script from "./TextText.vue?vue&type=script&lang=js&"
export * from "./TextText.vue?vue&type=script&lang=js&"
import style0 from "./TextText.vue?vue&type=style&index=0&id=bb5b53dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5b53dc",
  null
  
)

export default component.exports